export default "__VITE_ASSET__c5744587__"